import { render, staticRenderFns } from "./ddbjwcj.vue?vue&type=template&id=1e226e6c&scoped=true&"
import script from "./ddbjwcj.vue?vue&type=script&lang=js&"
export * from "./ddbjwcj.vue?vue&type=script&lang=js&"
import style0 from "./ddbjwcj.vue?vue&type=style&index=0&id=1e226e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e226e6c",
  null
  
)

export default component.exports